import React, { memo } from "react";
import {
  isEmpty
} from "lodash";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import OrderPriceActionsSelector from "./OrderPriceActionsSelector";

import ItemsTableHeader from "./ItemsTableHeader";
import ProductsTable from "./ProductsTable";
import OrderSummary from "./OrderSummary";
import ButtonComponent from "../../../../../components/ButtonMC";

import { useOrderItems } from "../../../hooks/useOrderItems";

const OrderItems = () => {
  const { t } = useTranslation('Orders');

  const {
    getValues,
    setValue,
    formState: { errors },
    control
  } = useFormContext();

  const {
    selectedAllProducts,
    selectedItems,
    orderSummary,
    selectedProducts,
    currency,
    currency_symbol,
    discount_type: discountType,
    discount_reason: discountReason,
    validItems,
    customTaxes,
    addNewLineItem,
    selectAllProducts,
    handlePriceChange,
    selectOrderItem,
    handleInputEdit,
    setEditTax,
    openProductDiscount,
    removeProduct,
    handleOrderDiscount
  } = useOrderItems({
    getValues,
    setValue,
    useWatch,
    control
  });

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <div className="tw-flex tw-flex-col tw-gap-2">
        <span className="tw-font-semibold tw-text-sm">{t('itemsBox.title')}</span>

        <div className={`tw-flex tw-flex-col tw-relative ${selectedItems.length ? 'tw-pt-2.5' : ''}`}>
          {selectedItems.length > 0 && (
            <OrderPriceActionsSelector
              selectedAllProducts={selectedAllProducts}
              selectAllProducts={selectAllProducts}
              handlePriceChange={handlePriceChange}
            />
          )}

          <div className="tw-block tw-w-full tw-overflow-x-auto tw-overflow-y-visible tw-webkit-overflow-scrolling-touch">
            {!isEmpty(selectedProducts) && selectedItems.length === 0 && (
              <ItemsTableHeader
                selectedAllProducts={selectedAllProducts}
                selectAllProducts={selectAllProducts}
              />
            )}
            <ProductsTable
              currencySymbol={currency_symbol}
              currency={currency}
              selectedProducts={selectedProducts}
              selectOrderItem={selectOrderItem}
              handleInputEdit={handleInputEdit}
              setEditTax={setEditTax}
              openProductDiscount={openProductDiscount}
              removeProduct={removeProduct}
            />
            {errors.selectedProducts?.message && (
              <div className="tw-flex tw-px-1">
                <span className="tw-text-xs tw-text-red-500">
                  {errors.selectedProducts?.message}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="tw-flex tw-justify-center tw-items-center">
        <ButtonComponent
          text={t('itemsBox.addProduct')}
          onClick={addNewLineItem}
          className="tw-px-6 tw-py-1"
          variant="SECONDARY"
          outlined
        />
      </div>

      <OrderSummary
        currencySymbol={currency_symbol}
        validItems={validItems}
        orderSummary={orderSummary}
        currency={currency}
        handleOrderDiscount={handleOrderDiscount}
        customTaxes={customTaxes}
        discountType={discountType}
        totalDiscount={orderSummary.total_discount}
        discountReason={discountReason}
      />
    </div>
  );
};

export default memo(OrderItems);
